module.exports = __webpack_public_path__ + "static/media/ic_challenged_yellow.77efd85e.svg";